import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import LoadingScreen from "@/components/LoadingScreen";
import { formatDateTime } from "@/lib/utils";

export default function AdminAuditPage() {
  const [logs, setLogs] = useState(null);
  useEffect(() => { api.get("/admin/audit-logs").then(({ data }) => setLogs(data)); }, []);
  if (!logs) return <LoadingScreen />;
  return (
    <div className="sqit-card overflow-hidden">
      <div className="p-6 pb-4">
        <h3 className="font-display text-lg font-semibold text-gray-900">Audit Logs</h3>
        <p className="text-xs text-gray-500 mt-1">Sensitive administrative activity.</p>
      </div>
      <table className="w-full text-sm">
        <thead className="bg-gray-50 border-y border-[#E5E7EB]">
          <tr>
            <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">When</th>
            <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Actor</th>
            <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Action</th>
            <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Target</th>
            <th className="text-left px-6 py-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Meta</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((l) => (
            <tr key={l.id} className="border-b border-gray-100">
              <td className="px-6 py-3 text-xs text-gray-500">{formatDateTime(l.created_at)}</td>
              <td className="px-6 py-3 text-xs">
                <div className="font-medium">{l.actor_role}</div>
                <div className="text-gray-500">{l.actor_id?.slice(0, 8)}</div>
              </td>
              <td className="px-6 py-3">{l.action}</td>
              <td className="px-6 py-3 text-xs text-gray-500">{l.target || "—"}</td>
              <td className="px-6 py-3 text-xs font-mono text-gray-500 max-w-md truncate">
                {l.meta ? JSON.stringify(l.meta) : "—"}
              </td>
            </tr>
          ))}
          {logs.length === 0 && <tr><td colSpan={5} className="px-6 py-8 text-center text-gray-500">No audit entries yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
